<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.4074 10.9375V6.25C16.4074 4.09264 14.6585 2.34375 12.5012 2.34375C10.3438 2.34375 8.59491 4.09264 8.59491 6.25V10.9375M20.4241 8.8617L21.7399 21.3617C21.8127 22.0536 21.2702 22.6562 20.5745 22.6562H4.42786C3.73212 22.6562 3.18959 22.0536 3.26242 21.3617L4.57821 8.8617C4.64099 8.26528 5.14393 7.8125 5.74365 7.8125H19.2587C19.8584 7.8125 20.3613 8.26528 20.4241 8.8617ZM8.98553 10.9375C8.98553 11.1532 8.81064 11.3281 8.59491 11.3281C8.37917 11.3281 8.20428 11.1532 8.20428 10.9375C8.20428 10.7218 8.37917 10.5469 8.59491 10.5469C8.81064 10.5469 8.98553 10.7218 8.98553 10.9375ZM16.798 10.9375C16.798 11.1532 16.6231 11.3281 16.4074 11.3281C16.1917 11.3281 16.0168 11.1532 16.0168 10.9375C16.0168 10.7218 16.1917 10.5469 16.4074 10.5469C16.6231 10.5469 16.798 10.7218 16.798 10.9375Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBuy',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
